export const medicalCardTemplatesApi = {
  createMedicalCardTemplate: (): string =>
    `/api/portal/staff/medical/doctor/patient-qualification-templates`,
  updateMedicalCardTemplate: (medicalCardTemplateId: string): string =>
    `/api/portal/staff/medical/doctor/patient-qualification-templates/${medicalCardTemplateId}`,
  fetchMedicalCardTemplateList: (): string =>
    `/api/portal/staff/medical/doctor/patient-qualification-templates`,
  fetchMedicalCardTemplate: (medicalCardTemplateId: string): string =>
    `/api/portal/staff/medical/doctor/patient-qualification-templates/${medicalCardTemplateId}`,
  deleteMedicalCardTemplate: (medicalCardTemplateId: string): string =>
    `/api/portal/staff/medical/doctor/patient-qualification-templates/${medicalCardTemplateId}`,
};
